import script from "./Webhook.vue?vue&type=script&setup=true&lang=js"
export * from "./Webhook.vue?vue&type=script&setup=true&lang=js"

import "./Webhook.vue?vue&type=style&index=0&id=824d47ea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-824d47ea"]])

export default __exports__